import {
  BadgeGreen,
  BadgeBlue,
  BadgeZinc,
  BadgePurple,
  BadgeAmber,
} from "../../components/badge/Badge";

import { SellarDistributionCollectionListResponseType } from "@sellar-io/api-v2/types";

export const distributionCollectionStatus = (
  status: SellarDistributionCollectionListResponseType["data"][number]["status"],
) => {
  switch (status) {
    case "processing":
      return <BadgeZinc icon={"AUTORENEW"}>Processing</BadgeZinc>;
    case "pending":
      return (
        <BadgeAmber icon={"TIMER_SAND_EMPTY"}>Collection scheduled</BadgeAmber>
      );
    case "ready":
      return <BadgeGreen icon={"CHECK_CIRCLE"}>Ready to pick</BadgeGreen>;
    case "dispatched":
      return <BadgePurple icon={"DELIVERY_BOX"}>Dispatched</BadgePurple>;
    case "delivered":
      return <BadgeBlue icon={"CHECK_ALL"}>Delivered</BadgeBlue>;
  }
};
